import { Component, OnInit } from '@angular/core';
import { ServiceTypeService } from '../../../../services/service-type.service';
import { HelpersService } from '../../../../services/helpers.service';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-workshop-custom-questions',
  templateUrl: './workshop-custom-questions.component.html',
  styleUrls: ['./workshop-custom-questions.component.scss'],
})
export class WorkshopCustomQuestionsComponent implements OnInit {
  public partner: any = {};
  public loading: boolean = false;
  public customQuestions: any = [];
  public serviceTypes: any = [];

  public customQuestionsTemplate = [
    {
      icon: 'fa-keyboard-o',
      name: this.translate.instant(
        'bikeshop.rentals.custom_questions.text_input',
      ),
      controlType: 'TEXTINPUT',
    },
    {
      icon: 'fa-file-code-o',
      name: this.translate.instant(
        'bikeshop.rentals.custom_questions.text_area',
      ),
      controlType: 'TEXTAREA',
    },
    {
      icon: 'fa-check-square-o',
      name: this.translate.instant(
        'bikeshop.rentals.custom_questions.checkbox',
      ),
      controlType: 'CHECKBOX',
    },
  ];

  constructor(
    private confirmationService: ConfirmationService,
    private serviceTypeService: ServiceTypeService,
    private helpersService: HelpersService,
    private translate: TranslateService,
    private messageService: MessageService,
  ) {}

  ngOnInit() {
    this.partner = this.helpersService.getPartnerData();
    this.getServiceTypes();
    this.getCustomQuestions();
  }

  getCustomQuestions() {
    this.loading = true;
    this.serviceTypeService
      .getWorkshopCustomQuestions(this.partner.ID)
      .subscribe(
        (questions) => {
          this.customQuestions = questions;
          this.loading = false;
        },
        (err) => {
          this.loading = false;
        },
      );
  }

  getServiceTypes() {
    this.serviceTypeService
      .getWorkshopServiceTypes(this.partner.ID)
      .subscribe((res) => {
        this.serviceTypes = res.map((x) => {
          return { ...x, value: x.id, label: x.serviceType };
        });
      });
  }

  dropTemplate(event) {
    console.log(event);
    this.customQuestions.push({
      question: '',
      controlType: event.item.data.controlType,
      hint: '',
      mandatory: false,
    });
  }

  getTypeLabel(controlType) {
    return this.customQuestionsTemplate
      .filter((x) => {
        return x.controlType === controlType;
      })
      .pop().name;
  }

  isValid(question) {
    return question.question && question.question.length > 0;
  }

  saveQuestion(question, index) {
    question.saving = true;
    var data = { ...question, PartnerID: this.partner.ID };
    this.serviceTypeService.updateWorkshopCustomQuestion(data).subscribe(
      (res) => {
        this.customQuestions[index] = res;
        question.saving = false;
        this.messageService.add({
          life: 2000,
          detail: this.translate.instant(
            'bikeshop.rentals.custom_questions.question_saved',
          ),
        });
      },
      (err) => {
        question.saving = false;
      },
    );
  }

  deleteQuestion(question, index) {
    this.confirmationService.confirm({
      acceptLabel: this.translate.instant('general.yes'),
      rejectLabel: this.translate.instant('general.no'),
      message: this.translate.instant(
        'bikeshop.workshop.custom_questions.delete_confirmation',
      ),
      accept: () => {
        this.customQuestions.splice(index, 1);
        if (question.id) {
          this.serviceTypeService
            .deleteWorkshopCustomQuestion(this.partner.ID, question.id)
            .subscribe(
              (res) => {},
              (err) => {},
            );
        }
      },
    });
  }

  linkServiceType(question, serviceTypeID) {
    if (
      question.linkedServiceTypes === null ||
      question.linkedServiceTypes === undefined
    ) {
      question.linkedServiceTypes = [];
    }

    if (!this.isServiceTypeLinked(question, serviceTypeID)) {
      question.linkedServiceTypes.push(serviceTypeID);
    } else {
      question.linkedServiceTypes.splice(
        question.linkedServiceTypes.indexOf(serviceTypeID),
        1,
      );
    }
  }

  isServiceTypeLinked(customQuestion, serviceTypeID) {
    return (
      customQuestion.linkedServiceTypes &&
      customQuestion.linkedServiceTypes.indexOf(serviceTypeID) > -1
    );
  }
}
